import {
  START_LOAD_PRODUCTS,
  FETCH_PRODUCTS_FAIL,
  FETCH_PRODUCTS_SUCCESS
} from '../../actions/products/products'

import {
  ADD_CATEGORY_OPTION,
  ADD_SUBCATEGORY_FILTER,
  REMOVE_CATEGORY_FILTER,
  REMOVE_SUBCATEGORY_FILTER,
  APPLY_SERIES_FILTER,
  REMOVE_SERIES_FILTER,
  SET_DIFFICULTY_FILTER,
  SET_INTENSITY_FILTER,
  CLEAR_DIFFICULTY_FILTER,
  CLEAR_INTENSITY_FILTER,
  SET_PRODUCT_ORDER,
  SET_FILTER_URL,
  APPLY_CATEGORY_FILTER,
  REPLACE_PRODUCT_FILTERS,
  CLEAR_ALL_SERIES_FILTERS,
  DEFAULT_SERIES_FILTERS
} from '../../actions/products/filters'

const defaultState = {
  isInitialLoad: true,
  isLoading: true,
  filterUrl: '',
  filters: {
    categories: {},
    instructors: [],
    equipment: [],
    focus_area: [],
    difficulties: [],
    intensities: [],
    excludeCompleted: false,
    page: 1
  }
}

let products = (state = defaultState, action) => {
  let categories
  let subcategories
  let seriesFilter

  switch (action.type) {
    case START_LOAD_PRODUCTS:
      const page = action.reloadAll ? 1 : state.filters.page + 1
      return Object.assign({}, state, {
        isLoading: true,
        isInitialLoad: action.reloadAll,
        filters: {
          ...state.filters,
          page
        }
      })
    case REPLACE_PRODUCT_FILTERS:
      return Object.assign({}, state, {
        filters: action.filters
      })
    case SET_FILTER_URL:
      return Object.assign({}, state, {
        filterUrl: action.url
      })
    case FETCH_PRODUCTS_FAIL:
      return Object.assign({}, state, {
        hasErrored: action.hasErrored
      })
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isInitialLoad: false,
        total: action.total
      }
    case APPLY_CATEGORY_FILTER:
      categories = state.filters.categories
      categories[action.category] = 'all'
      return Object.assign({}, state, {
        filters: {
          ...state.filters,
          categories
        }
      })
    case APPLY_SERIES_FILTER:
      if (action?.parentCategory === 'excludeCompleted') {
        return Object.assign({}, state, {
          filters: {
            ...state.filters,
            excludeCompleted: true
          }
        })
      }

      seriesFilter = state.filters[action?.parentCategory]
      const isContain = seriesFilter?.some((item) => {
        if (typeof item === 'string') {
          return item === action?.filter
        } else {
          return item.slug === action?.filter?.slug
        }
      })
      if (!isContain) {
        seriesFilter.push(action.filter)
      }
      return Object.assign({}, state, {
        filters: {
          ...state.filters,
          [action?.parentCategory]: seriesFilter
        }
      })
    case REMOVE_SERIES_FILTER:
      if (action?.parentCategory === 'excludeCompleted') {
        return Object.assign({}, state, {
          filters: {
            ...state.filters,
            excludeCompleted: false
          }
        })
      }
      seriesFilter = state.filters[action?.parentCategory]
      const updatedSlug = seriesFilter?.filter((item) => {
        if (typeof item === 'string') {
          return item !== action.filter
        } else {
          return item.slug !== action.filter
        }
      })
      return Object.assign({}, state, {
        filters: {
          ...state.filters,
          [action?.parentCategory]: updatedSlug
        }
      })
    case ADD_CATEGORY_OPTION:
      categories = state.filters.categories
      if (action.filter) {
        categories[action.filter] = []
      }
      return Object.assign({}, state, {
        filters: {
          ...state.filters,
          categories
        }
      })
    case ADD_SUBCATEGORY_FILTER:
      categories = state.filters.categories
      subcategories = categories[action.parentCategory]
      if (subcategories === 'all') {
        subcategories = []
      }
      subcategories.push(action.filter.slug)
      categories[action.parentCategory] = subcategories
      return Object.assign({}, state, {
        filters: {
          ...state.filters,
          categories
        }
      })
    case REMOVE_CATEGORY_FILTER:
      categories = state.filters.categories
      categories[action.filterSlug] = []
      return Object.assign({}, state, {
        filters: {
          ...state.filters,
          categories
        }
      })
    case REMOVE_SUBCATEGORY_FILTER:
      categories = state.filters.categories
      subcategories = categories[action.parentCategory]
      subcategories = subcategories.filter(
        (subcategory) => subcategory !== action.filterSlug
      )
      if (!action.clearParent && subcategories.length === 0) {
        categories[action.parentCategory] = 'all'
      } else {
        categories[action.parentCategory] = subcategories
      }

      return Object.assign({}, state, {
        filters: {
          ...state.filters,
          categories
        }
      })
    // case SET_DIFFICULTY_FILTER:
    //   return Object.assign({}, state, {
    //     filters: {
    //       ...state.filters,
    //       difficulty: action.difficulty
    //     }
    //   })
    // case SET_INTENSITY_FILTER:
    //   return Object.assign({}, state, {
    //     filters: {
    //       ...state.filters,
    //       intensity: action.intensity
    //     }
    //   })
    // case CLEAR_DIFFICULTY_FILTER:
    //   return Object.assign({}, state, {
    //     filters: {
    //       ...state.filters,
    //       difficulty: null
    //     }
    //   })
    // case CLEAR_INTENSITY_FILTER:
    //   return Object.assign({}, state, {
    //     filters: {
    //       ...state.filters,
    //       intensity: null
    //     }
    //   })
    case SET_PRODUCT_ORDER:
      return Object.assign({}, state, {
        filters: {
          ...state.filters,
          order: action.order
        }
      })
    case CLEAR_ALL_SERIES_FILTERS:
      return Object.assign({}, state, {
        filters: {
          categories: {
            yoga: [],
            fitness: [],
            mindfulness: [],
            wellness: [],
            skills: []
          },
          instructors: [],
          equipment: [],
          focus_area: [],
          difficulties: [],
          intensities: [],
          excludeCompleted: false,
          order: state.filters.order,
          page: 1
        }
      })
    case DEFAULT_SERIES_FILTERS:
      return { ...state, defaultFilter: action.defaultFilter }
    default:
      return state
  }
}

export default products
